/**
 * Type guard for custom errors from BE (for graceful error messages).
 * Needed for stricter type check when upgrading from TS v4.3 -> v4.9.
 *
 * Reference changelog - https://devblogs.microsoft.com/typescript/announcing-typescript-4-4/#use-unknown-catch-variables
 */

export interface CustomError {
    response?: {
        data?: {
            detail?: string;
        };
    };
}

export const isCustomError = (error: any): error is CustomError => {
  return error && error.response && error.response.data && typeof error.response.data.detail === 'string';
};
